class VimeoVideo
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'vimeo-video--bound'
            @.$playButton = @.$el.querySelector '.vimeo-video__play-button'
            @.$template = @.$el.querySelector 'template'
            @.$vimeoEmbedIframe = undefined
            @.loaded = @.$el.classList.contains 'vimeo-video--loaded'
            @.player = undefined
            @.playerScript = 'https://player.vimeo.com/api/player.js'

            @.$el.classList.add 'vimeo-video--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.AppendPlayerScript()
        if !@.loaded
            @.$playButton.addEventListener 'click', (e) ->
                self.AppendTemplateAndLoad()
                return
        window.addEventListener 'stopAllVimeoVideos', (e) ->
            self.PauseVideo()
            return
        return

    AppendPlayerScript: ->
        bindedPlayerScript = document.getElementById 'vimeo-player-script'
        if !bindedPlayerScript
            playerScript = document.createElement 'script'
            playerScript.id = 'vimeo-player-script'
            playerScript.src = @.playerScript
            document.querySelector('head').appendChild playerScript
        return

    AppendTemplateAndLoad: ->
        self = @
        @.$template.content.querySelector('iframe').src += '&autoplay=1&api=1'
        @.$el.appendChild document.importNode(@.$template.content, true)
        @.$vimeoIframe = @.$el.querySelector 'iframe'
        @.$vimeoIframe.addEventListener 'load', (e) ->
            self.$el.classList.add 'vimeo-video--loaded'
            self.player = new Vimeo.Player self.$vimeoIframe
            return
        return

    PauseVideo: ->
        if typeof @.player != "undefined"
            @.player.pause()
        return

BindVimeoVideos = ->
    document.querySelectorAll '.vimeo-video:not(.vimeo-video--bound)'
        .forEach (el) ->
            new VimeoVideo el
            return
    return

window.addEventListener 'bind-components', BindVimeoVideos